/* eslint-disable no-undef */
import React, { Component, useState, useEffect } from "react";
import { Trans, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from "axios";
import subscribe from "../../auth/subscribe";
import FloatingAlert from "../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../helpers/bgSliders";
import { setAgencyData, logtracker ,saveTracker} from "../../helpers/agencyTracker";
import { setLoginData } from "../../helpers/helpers";
import "./secondAsiacellSubscribePage.scss";
import * as localLang from "../../i18n/i18n";
import NewAsiacellSubscribePageDisplay from "./secondAsiacellSubscribePage.styled";
import { useHistory } from 'react-router-dom';

import { getPhoneByHeader } from "./services"
import { isMobile } from 'react-device-detect';
import Modal from "react-modal";

function secondAsiacellSubscribePage({ t }) {
  const history = useHistory();
  const [enriched, setenriched] = useState(false);
  // const [activeData, setActiveData] = useState('');
  // const [headers, setHeaders] = useState('');
  const [clickId, setClickId] = useState('');

  const [Antifraud, setAntifraud] = useState('');
  const [scriptReady, setScriptReady] = useState(false);

  const [headerData, setHeaderData] = useState({});


  const [showverify, setShowverify] = useState(false);
  const [showsubscribeSucess, setShowsubscribeSucess] = useState(false);

  const [showLoading, setshowLoading] = useState(true);
  const [errorMesg, setErrorMesg] = useState(false);
  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const [visibleModal, setvisibleModal] = useState(false);

  
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };






  useEffect(() => {
    const lang = localStorage.getItem('i18nextLng');
    if (lang !== 'ar' || !lang) {
      localStorage.setItem("i18nextLng", 'ar');
      localLang.setlangSubscribe();
    }
        const urlsearch = window.location.search;

    if (urlsearch !== "") {
      //console.log("tracker")
       setAgencyData(urlsearch);
     }
     const companyName = localStorage.getItem("trackerCompany");
   // fetchData('pv',companyName);
   fetchit();
    
    

  }, [])
  const fetchData = async (event ,company ) => {
    try {
       await axios.get(`https://apissl.playit.mobi/api/v2/asia-cell-iraq/monitor?event=${event}&company=${company}`);
      //setData(response.data);
    } catch (error) {
      console.error("Fetch error: ", error);
    }
  };
  function gtag_report_conversion() {
    let tracker_value = localStorage.getItem('tracker');
      if(localStorage.getItem(tracker_value) != '1'){
        window.gtag('event', 'conversion', {
          'send_to': 'AW-619421651/C_ScCIHe_qcZENO_rqcC'
      });
      localStorage.setItem(tracker_value,'1')
    }
    return false;
  }



  async function fetchit() {
    var linkheader = "http://aciq.playit.mobi/checkheaderasiacell.php";
    setshowLoading(true);
    setScriptReady(false);

    const headerData = await getPhoneByHeader(linkheader);
    //console.log('headerData', headerData.Headers);


    /*  const headerData = {
      Msisdn: 9647748475064,
  Headers: 'eyJNc2lzZG4iOiI5NjQ3NzQ4NDc1MDY0IiwiQWNjZXB0LUVuY29kaW5nIjoiZ3ppcCwgZGVmbGF0ZSIsIlJlZmVyZXIiOiJodHRwOi8vYWNpcS5wbGF5aXQubW9iaS9zaWdudXAvP3BhcmFtZXRlcj13cHNzdnQ2YmlvaGsxNWY5M2dtN2dqNGcmdHJhZmZpY3NvdXJjZT1WaWN0b3J5YWRzIiwiVXNlci1BZ2VudCI6Ik1vemlsbGEvNS4wIChMaW51eDsgQW5kcm9pZCAxMTsgVEVDTk8gTEU2IEJ1aWxkL1NQMUEuMjEwODEyLjAxNikgQXBwbGVXZWJLaXQvNTM3LjM2IChLSFRNTCwgbGlrZSBHZWNrbykgQ2hyb21lLzEwMy4wLjUwNjAuMTI5IE1vYmlsZSBTYWZhcmkvNTM3LjM2IiwiQWNjZXB0IjoiYXBwbGljYXRpb24vanNvbiwgdGV4dC9wbGFpbiwgKi8qIiwiQWNjZXB0LUxhbmd1YWdlIjoiYXItSVEsIGFyLUlRO3E9MC44LCBkYS1ESztxPTAuNCIsIkNvbm5lY3Rpb24iOiJrZWVwLWFsaXZlIiwiQ29udGVudC1MZW5ndGgiOiIiLCJDb250ZW50LVR5cGUiOiIiLCJIb3N0IjoiYWNpcS5wbGF5aXQubW9iaSJ9',
  UserIP:'MjEyLjk1LjEzMi4xNjY='
     } */



    // HE
        const parameter = localStorage.getItem("tracker");

    if (headerData.Msisdn) {
                 fetchData('call_check_success_2',parameter);

      setHeaderData(headerData)
      headerSignup(headerData);

    } else {
      setshowLoading(false);
      setScriptReady(false);
    }


  }


      // save tracker
  const tracker = async (GMSISDN) => {
        var datag = {};
        if (localStorage.getItem('tracker')) {
          var op_id = 'mOR5fK6fLj';
    
    
          datag = {
            key: 'parameter',
            company: localStorage.getItem("trackerCompany"),
            value: localStorage.getItem('tracker'),
            identifierKey: 'id',
            identifierValue: op_id,
            phoneNum: GMSISDN
          };
         //console.log(datag)
    
        }
        await saveTracker(datag);
    
  }

  const signup = async (e) => {
    e.preventDefault();
   //console.log("Subscribe", isMobile);
    // window.gtag('event', 'conversion', {
    //   'send_to': 'AW-619421651/h391CMWV4dcYENO_rqcC'
    // });
   //console.log("after conversion");
    if (isMobile) {
      window.location.href = 'sms:2231;?&body=1';
    }
    else{
      
      setvisibleModal(true);
      setTimeout(() => {
        setvisibleModal(false);

      }, 5000);

    }

    // fetchit();
  }

  const headerSignup = async (headerData) => {
  const parameter = localStorage.getItem("tracker");

  const body = {
    headers: headerData.Headers,
    userip: headerData.UserIP,
    msisdn: headerData.Msisdn,
    page: 2,
  };

  setshowLoading(true);
  setScriptReady(false);

  axios.post("https://apissl.playit.mobi/api/v2/asia-cell-iraq/get-script", body, {
    headers: { "Content-Type": "application/json" }
  })
    .then(res => {
      fetchData('call_script_2', parameter);

      if (res.data) {
        localStorage.setItem("msisdn", headerData.Msisdn);

        const addScript = document.createElement('script');
        addScript.innerHTML = res.data.message;
        document.head.appendChild(addScript);

        setClickId(res.data.clickId);
        setAntifraud(res.data.AntiFrauduniqid);
        localStorage.setItem("AntiFrauduniqid", res.data.AntiFrauduniqid);
        setenriched(true);
        setScriptReady(true);
      } else {
        setErrorMesg(true);
        setErrorMesgSubscribe(res.data.message);
        setScriptReady(false);
        // setshowagin(true)
      }

      setshowLoading(false);
    })
    .catch(error => {
      // You can log or handle error here
      setScriptReady(false);
      setshowLoading(false);
    })
    .finally(() => {
      // console.log('complete');
    });
};


  // function gtag_report_conversion() {
  //   window.gtag('event', 'conversion', {
  //       'send_to': 'AW-619421651/h391CMWV4dcYENO_rqcC'
  //   });
  // }
  
  const verfiy = async () => {
   
    const companyName = localStorage.getItem("trackerCompany");
    const AntiFrauduniqid = localStorage.getItem("AntiFrauduniqid");
   const msisdn = localStorage.getItem("msisdn");
    //fetchData('2nd_click', companyName);
    var url = `https://apissl.playit.mobi/api/v2/asia-cell-iraq/subscribe2?msisdn=${msisdn}&clickID=${AntiFrauduniqid}`;
    setshowLoading(true);
    axios.get(url)
      .then(res => {
     
        
        if (res.data.status == true) {
          gtag_report_conversion();
          tracker(msisdn);
          setshowLoading(false);
          history.push("/thank-asiacell");

          if (res.data.user_id) {
            setLoginData(
              res.data.user_id,
              res.data.token,
              res.data.user_name,
              res.data.photo,
              res.data.operator_id,
              res.data.user_email,
              res.data.msisdn
            );
          }

        }

        else {
          setErrorMesg(true);
          setErrorMesgSubscribe(res.data.message)
          // setshowagin(true)
        }

        setshowLoading(false);


      })
      .catch(function (error) {
       //console.log(error);
        // setErrorMesg(true)
      })
      .finally(function () {
       //console.log('complete');
      });
  }
  // const { t } = this.props;

  return (
    <NewAsiacellSubscribePageDisplay className="" bgImg="">

      {errorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMesgSubscribe}</Trans>
        </FloatingAlert>
      ) : null}

      {showLoading ?
        <div className="load">
          <div className="spinerC">
            <div className="spinner"></div>
          </div>
        </div>
        : null}

      {/*} {verfiErrorMesg ? (
      <FloatingAlert type={"error"}>
        <Trans>register.VERIFYERROR</Trans>
      </FloatingAlert>
   ) : null} */}

      <div className="formPage">
        <form
        // onSubmit={(e) => {
        //   signup(e);
        // }}
        >
          <div className="formsLayout">
            <div className="header">
                <div className="logo" />
            </div>
            <div className="links-Section links-SectionGamezorid">
              <div className="games_img"></div>



              <div className="normBtn">
                <p className="free_text"><Trans>asiacellSubscribe.part1</Trans></p>





                {showverify ?
                  <div>
                    <button
                      className="btn AFsubmitbtn"
                      type="button"
                      disabled={!scriptReady || showLoading}
                      onClick={() => verfiy()}
                    >
                      <Trans>asiacellSubscribe.confirm</Trans>
                    </button>
                  </div>

                  :
                  <div>
                  <button
                    className="btn"
                    type="button"
                    disabled={!scriptReady || showLoading}
                    onClick={() => {
                      if (!scriptReady) {
                        return;
                      }
                      verfiy();
                    }}
                  >
                    <Trans>asiacellSubscribe.confirm</Trans>

                  </button>

                 

                <Modal
                isOpen={visibleModal}
                style={customStyles}
                contentLabel="Example Modal"
              >
               
  
                <div className="btnsModal btnsMobModal">
                <p className="messageModal">
                <Trans>asiacellSubscribe.message</Trans>
              </p>
                 
                </div>
              </Modal>
                </div>



                }
              </div>
              <div>
                <p className="sub_text"><Trans>asiacellSubscribe.part2</Trans></p>
              </div>


            </div>


            <div className="footer">

              <p>
                <Trans>accept_subscribe</Trans>{" "}
                <Link to="tos">
                  <Trans>terms_and_conditions</Trans>
                </Link>
              </p>
              <div className="header header-ksa">
                <Link to="/">
                  <div className="logo singupLogo" />
                </Link>
              </div>
            </div>


          </div>
        </form>
      </div>
    </NewAsiacellSubscribePageDisplay>
  );

}
export default withTranslation()(secondAsiacellSubscribePage);
